export const isBrowser = typeof globalThis.window !== 'undefined';

export const safeLocalStorage: Storage = (() => {
  if (isBrowser) {
    try {
      const key = '__storage_test__';
      globalThis.localStorage.setItem(key, key);
      globalThis.localStorage.removeItem(key);
      return globalThis.localStorage;
    } catch {
      /* ignore */
    }
  }

  const store: Record<string, string> = {};

  return {
    getItem: (key: string) => (key in store ? store[key] : null),
    setItem: (key: string, value: string) => {
      store[key] = value;
    },
    removeItem: (key: string) => {
      delete store[key];
    },
    clear: () => {
      Object.keys(store).forEach(key => delete store[key]);
    },
    key: (index: number) => Object.keys(store)[index] ?? null,
    get length() {
      return Object.keys(store).length;
    }
  } as Storage;
})();
